var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"text-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_c('v-btn',{attrs:{"large":"","color":"success"},on:{"click":_vm.loginAction}},[_vm._v("現在のＬＩＮＥログインを使用して継続")])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }